module.exports = __webpack_public_path__ + "static/media/nav-personality-active.6c600cc2.svg";